import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const createNewComponentPagePlugin = createPlugin({
  id: 'create-new-component-page',
  routes: {
    root: rootRouteRef,
  },
});

export const CreateNewComponentPagePage = createNewComponentPagePlugin.provide(
  createRoutableExtension({
    name: 'CreateNewComponentPagePage',
    component: () =>
      import('./components/OptimizedCreateNewComponentPage').then(
        m => m.OptimizedCreateNewComponentPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
